var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"block bg-blue-600 text-base bg-opacity-75 hover:bg-opacity-50 focus:bg-red-500 focus:bg-opacity-50 text-white font-semibold rounded py-3 px-4",on:{"click":function($event){return _vm.$emit('pressed')}}},[_c('i',{staticClass:"fas fa-exclamation-triangle mr-2"}),_vm._v(" Upgrade Account\n       ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }